module.exports = __webpack_public_path__ + "img/write_first_review.121dbd4b.png";